import React from 'react';

import {
    AjaxListingContext,
    AjaxListingNextButton
} from '$partials/base/ajax-listing';

import {
    Footer,
    Header
} from '$partials/global';

import { EventListingItem } from '$partials/items';
import { useAjaxListing } from '$hooks/ajax-listing';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').EventLocationDetailPage}
 */
const EventLocationDetailPage = (props) => {
    const page = props.data.page;

    const listing = useAjaxListing({
        infinite: true,
        items: page?.items?.edges,
        page: page?.items?.pageInfo?.page,
        path: `/api/v1/listings${page?.url ?? ''}`,
        totalItems: page?.items?.total,
        totalPages: page?.items?.pageInfo?.totalPages
    });

    return (
        <>
            <Header
                {...props?.data?.header}
                pageType={page.__typename} />

            <AjaxListingContext.Provider value={listing}>
                <main id='main-content'>
                    <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                        <div className='col-wrapper-breakout bg-surface-panel-yellow rounded-lg pt-24 pb-8 flex flex-wrap'>
                            {/* Heading */}
                            <section className='w-full flex flex-col pb-panel-gap-large col-padding'>
                                <h1 className='type-style-sans-display'>
                                    {page.title}
                                </h1>
                            </section>

                            {/* Listing */}
                            <section
                                aria-busy={listing?.loading}
                                aria-label='Event listing'
                                className='w-full col-padding'
                                role='feed'>
                                <h2 className='sr-only'>
                                    Events feed
                                </h2>

                                <div className='flex flex-col gap-16'>
                                    {listing?.items?.map((itm, idx) => {
                                        return (
                                            <article
                                                aria-labelledby={itm.node.title}
                                                aria-posinset={idx + 1}
                                                aria-setsize={listing.items.length}
                                                className=''
                                                key={itm.node.id + '-' + idx}>
                                                <EventListingItem {...itm.node} />
                                            </article>
                                        );
                                    })}
                                </div>

                                {(listing?.items?.length > 0) ? (
                                    listing?.page !== listing?.totalPages && (
                                        <AjaxListingNextButton
                                            aria-label='Load more events'
                                            className='button-outcome mt-40'>
                                            <span>Load more&hellip;</span>
                                        </AjaxListingNextButton>
                                    )
                                ) : (
                                    <p className='type-style-sans-body'>
                                        No events

                                        <span className='sr-only'>
                                            Found
                                        </span>
                                    </p>
                                )}
                            </section>
                        </div>
                    </div>
                </main>
            </AjaxListingContext.Provider>

            <Footer
                {...props?.data?.footer}
                exploreHide={true}
                magazineHide={true}
                pageType={page.__typename} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default EventLocationDetailPage;
